const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
]

export function formatDate(mydate) {
  let dateObj = new Date(mydate)
  if (isNaN(dateObj)) return mydate
  let year = dateObj.getFullYear().toString()
  let month = dateObj.toLocaleString('default', { month: 'long' })
  let weekday = days[dateObj.getDay()]
  let date = dateObj.getDate()
  return weekday + ", " + month + " " + date + ", " + year
}

export function formatTime(mydate) {
  let dateObj = new Date(mydate)
  if (isNaN(dateObj)) return ''
  return dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
}
